const config = {
    apiUrl:
        window._env_?.VITE_CHAPERON_API_URL ||
        import.meta.env.VITE_CHAPERON_API_URL,
}

export default config
